export const lowercaseComparator = (str1, str2) => {
    return str1.toLowerCase().localeCompare(str2.toLowerCase());
}

export const priceComparator = (price1, price2) => {
    if(price1 === '?' && price2 === '?') return 0;
    if(price1 === '?') return 1;
    if(price2 === '?') return -1;
    if(price1 > price2) return 1;
    if(price1 < price2) return -1;
    return 0;
}
